import {Component, ViewEncapsulation} from '@angular/core';
import {UserModel} from "./service/user.model";
import {AngularFirestore, AngularFirestoreCollection} from "angularfire2/firestore";
import {ReportModel} from "../reports/service/report.model";
import {Observable} from "rxjs/Observable";
import {NgbDatepickerConfig, NgbDatepickerI18n, NgbDateStruct, NgbModal, NgbTimeStruct} from '@ng-bootstrap/ng-bootstrap';
import {ToastyService} from "ng2-toasty";
import {IncidentModel} from "../reports/service/incident.model";
import {AreaModel} from "./service/area.model";
import {LocalStorageService} from "ngx-webstorage";
import {Router} from "@angular/router";
import {DocumentModel} from "../documents/service/document.model";
import {AjustesModel} from "../ajustes/service/ajustes.model";
import {CustomDatepickerI18n, I18n} from "../common/datepicker.custom";
import {VisitModel} from "../reports/service/visit.model";
import {FormControl} from "@angular/forms";

import * as emailjs from "../../../node_modules/emailjs-com/src/index";
import {DatePipe} from '@angular/common';
import swal from 'sweetalert2';
import {AngularFireStorage} from 'angularfire2/storage';
import {finalize} from 'rxjs/operators';

@Component({
  selector: 'app-public',
  templateUrl: './public.component.html',
  styleUrls: ['public.component.css'],
  providers: [I18n, {provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n}, NgbDatepickerConfig],
  encapsulation: ViewEncapsulation.None, // Ensures styles are applied globally

})
export class PublicComponent {
  private reportsCollection: AngularFirestoreCollection<ReportModel>;
  items: Observable<ReportModel[]>;

  private areasCollection: AngularFirestoreCollection<AreaModel>;
  areas: Observable<AreaModel[]>;

  private tiposCollection: AngularFirestoreCollection<AreaModel>;
  tipos: Observable<any[]>;

  private incidentsCollection: AngularFirestoreCollection<IncidentModel>;
  itemIncidents: Observable<IncidentModel[]>;

  private reportDocument: AngularFirestoreCollection<DocumentModel>;
  itemsDocuments: Observable<DocumentModel[]>;

  newItemIncident: IncidentModel;
  newItemsIncidents: IncidentModel[];
  newItemReport: ReportModel;

  firstVisitDate: any;
  firstVisitTime: any;
  minTime: NgbTimeStruct = { hour: 10, minute: 0, second: 0 }; // Minimum selectable time
  maxTime: NgbTimeStruct = { hour: 16, minute: 0, second: 0 }; // Maximum selectable time

  NEW_REPORT = 'N';
  PROCESS_REPORT = 'P';
  FINISHED_REPORT = 'F';

  // Estados de las incidencias
  NEW_INCIDENT = 'N';
  PROCESS_INCIDENT = 'P';
  DENIED_INCIDENT = 'D';
  FINISHED_INCIDENT = 'F';

  itemReportSelected: ReportModel;
  itemIncidentSelected: IncidentModel[];

  user: UserModel;
  private PATH_REPORTS = 'reports/';

  messageEmail: string;

  // para subir imágenes de evidencia inicial
  selectedFiles: File[] = [];
  previewUrls: string[] = [];
  downloadUrls: string[] = [];




  ctrl = new FormControl('', (control: FormControl) => {
    const value = control.value;

    if (!value) {
      return null;
    }

    const d = new Date(this.firstVisitDate.year, this.firstVisitDate.month - 1, this.firstVisitDate.day);

    if (d.getDay() === 1 || d.getDay() === 2 || d.getDay() === 3 || d.getDay() === 4 || d.getDay() === 5) {
      if (value.hour < 10) {
        return {tooFail: true};
      }
      if (value.hour > 16) {
        return {tooFail: true};
      }
    } else if (d.getDay() === 6) {
      if (value.hour < 9) {
        return {tooFail: true};
      }
      if (value.hour > 13) {
        return {tooFail: true};
      }
    }

    return null;
  });

  dropdownLugarOpen = false;
  selectedOptionLugar: string | null = null;
  searchTermLugar = '';
  dropdownOpen = false;
  selectedOption: string | null = null;
  searchTerm = '';
  optionsLugar: any[] = [
  ];
  optionsTipo: any[] = [
  ];

  constructor(private db: AngularFirestore,
              private toastyService: ToastyService,
              private localSt: LocalStorageService,
              private router: Router,
              private modalService: NgbModal,
              config: NgbDatepickerConfig,
              public datePipe: DatePipe,
              private storage: AngularFireStorage) {
    this.firstVisitDate = {};

    this.newItemIncident = <IncidentModel>{};
    this.newItemIncident.area = null;

    this.user = this.localSt.retrieve('usr-ss');
    if (!this.user)
      this.user = new UserModel();

    console.log("this.user", this.user);

    this.reportsCollection = db
      .collection<ReportModel>('reports', ref =>
        ref.where('client.id', '==', this.user.id)
          .orderBy('created_at', 'desc')
      );
    //noinspection TypeScriptValidateTypes
    this.items = this.reportsCollection
      .snapshotChanges()
      .map(res => {
        return res.map(a => {
          const data = a.payload.doc.data() as ReportModel;
          const id = a.payload.doc.id;
          return {id, ...data};
        });
      });

    this.areasCollection = db.collection<AjustesModel>('areas', ref => ref.orderBy('created_at', 'desc'));
    //noinspection TypeScriptValidateTypes
    this.areas = this.areasCollection
      .snapshotChanges()
      .map(res => {
        return res.map(a => {
          const data = a.payload.doc.data() as AreaModel;
          console.log(data);
          const id = a.payload.doc.id;
          return {id, ...data};
        });
      });

    // Subscribe to the observable and fill the array
    this.areas.subscribe((data) => {
      this.optionsLugar = data; // Update the array with the fetched documents
      console.log('OPTIONS LUGAR', this.optionsLugar);
    });

    this.tiposCollection = db.collection<AjustesModel>('tipos', ref => ref.orderBy('created_at', 'desc'));
    //noinspection TypeScriptValidateTypes
    this.tipos = this.tiposCollection
      .snapshotChanges()
      .map(res => {
        return res.map(a => {
          const data = a.payload.doc.data() as AreaModel;
          //console.log(data);
          const id = a.payload.doc.id;
          return {id, ...data};
        });
      });

    // Subscribe to the observable and fill the array
    this.tipos.subscribe((data) => {
      var arr = [];
      data.forEach(tipo => {
        if (tipo.visible){
          arr.push(tipo);
          console.log('OPTIONS TIPO', this.optionsTipo);
        }
      });
      this.optionsTipo = arr; // Update the array with the fetched documents

    });

    this.reportDocument = this.db.collection<DocumentModel>('projects/' + this.user.project_client + '/docs/');
    //noinspection TypeScriptValidateTypes
    this.itemsDocuments = this.reportDocument
      .snapshotChanges()
      .map(res => {
        return res.map(a => {
          const data = a.payload.doc.data() as DocumentModel;
          const id = a.payload.doc.id;
          return {id, ...data};
        });
      });

    // init emailjs
    emailjs.init('user_jFxtnwh8pbKTGSA3EMg7L');
    // weekends are disabled
    config.markDisabled = (date: NgbDateStruct) => {
      const d = new Date(date.year, date.month - 1, date.day);
      return d.getDay() === 0;
    };
  }

  resolveState(item) {
    if (item.status === this.NEW_REPORT) {
      return 'En espera';
    } else if (item.status === this.PROCESS_REPORT) {
      return 'En proceso';
    } else if (item.status === this.FINISHED_REPORT) {
      return 'Terminado';
    }
  }

  openDetailReport(content: any, item: ReportModel) {
    this.itemReportSelected = item;
    this.incidentsCollection = this.db.collection<IncidentModel>('incident',
      ref => ref.where('report_reference', '==', 'reports/' + item.id));
    //noinspection TypeScriptValidateTypes
    this.itemIncidents = this.incidentsCollection.snapshotChanges()
      .map(res => {
        return res.map(a => {
          const data = a.payload.doc.data() as IncidentModel;
          const id = a.payload.doc.id;
          return {id, ...data};
        });
      });
    this.modalService.open(content).result.then((result) => {
    }, (reason) => {
      console.log(reason);
    });
  }

  validateNewReport() {
    console.log('this.newIncicent', this.newItemIncident)

    if (!this.firstVisitDate) {
      this.toastyService.warning('Favor de especificar una fecha de visita.');
      return false;
    }
    if (!this.firstVisitTime) {
      this.toastyService.warning('Favor de especificar una hora de visita.');
      return false;
    }
    if (!this.newItemsIncidents || this.newItemsIncidents.length == 0) {
      this.toastyService.warning('Favor de agregar al menos una incidencia.');
      return false;
    }
    if (this.firstVisitTime.hour < 8 || this.firstVisitTime.hour > 16) {
      this.toastyService.error('El horario de visita no esta disponible.');
      return false;
    }
    return true;
  }

  openNewReport(content) {
    this.newItemsIncidents = [];
    this.firstVisitDate = {};
    this.firstVisitTime = {};
    this.newItemIncident = <IncidentModel>{};
    this.modalService.open(content).result.then((result) => {
      if (result == 'SAVE')
        this.saveReport();
    }, (reason) => {
      console.log(reason);
      this.newItemIncident = <IncidentModel>{};
      this.newItemsIncidents = [];
      this.firstVisitDate = {};
      this.firstVisitTime = {};
    });
  }

  aggregateNewIncident() {
    if (!this.newItemsIncidents)
      this.newItemsIncidents = [];
    if (!this.newItemIncident ||
      !this.newItemIncident.area ||
      !this.newItemIncident.detail) {
      this.toastyService.warning('Favor de añadir valores a la incidencia.');
      return;
    }

    if (!this.newItemIncident.tipo) {
      this.toastyService.warning('Favor de especificar un tipo para la incidencia.');
      return false;
    }


    // temporalmente ponemos los archivos aquí
    this.newItemIncident.initial_evidence = this.selectedFiles;
    this.newItemsIncidents.push(this.newItemIncident);
    this.newItemIncident = <IncidentModel>{};
    this.selectedFiles = [];
    this.previewUrls = [];
    this.selectedOptionLugar = null;
    this.selectedOption = null;

    console.log('NEW ITEMS INCIDENT', this.newItemsIncidents);
  }

  async saveReport() {

    // todo: recorrer incidentes para obtener cuales entran dentro de la garantía y cual no

    var mensaje = `Estimado ${this.user.name} <br> Agradecemos el registro de tu incidencia, te informamos que tu incidencia ha sido registrada. Asimismo, te comunicamos que:<br><br>`;
    var noWarranty = true;
    this.newItemsIncidents.forEach( newItemIncident => {

      // validamos garantía solo si el tipo seleccionado tiene garantía
      if (newItemIncident.tipo.warranty === 'si'){

        if (this.user.deadline) {
          // si el tipo seleccionado sí tiene garantía, calcular los años desde la fecha de entrega al día de hoy
          const diff = new Date().getTime() - this.stringToDate(this.user.deadline).getTime();
          // Convert milliseconds to days
          const dayDifference = diff / (1000 * 60 * 60 * 24);
          console.log('daydiff', dayDifference);

          // ahora calcular cuantos años de garantía tiene el tipo seleccionado
          const warrantyDays = newItemIncident.tipo.warranty_time * 365;
          console.log('warrantyDays', warrantyDays);
          const finalDayDifference = warrantyDays - dayDifference;
          if (finalDayDifference <= 0){ // ya no hay garantía
            console.log('ya no hay garantía', finalDayDifference);

            mensaje += `La incidencia de tipo ${newItemIncident.tipo.name} que has reportado no procede
como una garantía, conforme al tiempo de entrega de tu vivienda, cuya fecha corresponde al ${this.timestampToDateString(this.stringToDate(this.user.deadline))}.
<br><br>`;
            // console.log('Mensaje', mensaje);
            // swal("Mensaje",mensaje,"warning")


          } else { // aún queda garantía

            // console.log('finalDayDiff', finalDayDifference);
            //console.log('aun queda garantía');
            noWarranty = false;
            /*mensaje += `La incidencia de tipo ${newItemIncident.tipo.name} que has registrado sí procede
como una garantía, de acuerdo con el tiempo de entrega de tu vivienda, que tiene fecha del ${this.timestampToDateString(this.stringToDate(this.user.deadline))}.<br><br>`
          */
          }

          // console.log('tipo', newItemIncident.tipo)
        }
      } else {
        mensaje += `La incidencia de tipo ${newItemIncident.tipo.name} que has registrado no procede
como una garantía, ya que no está contemplada dentro de la póliza de garantía de tu vivienda que
puedes consultar en este mismo portal. <br><br>`;
        //console.log('Mensaje', mensaje);
      }

    });


    // si no hubo ninguna modificación en el mensaje, quiere decir que la garantía sí procede así que mostramos otro mensaje
    if (mensaje === `Estimado ${this.user.name} <br> Agradecemos el registro de tu incidencia, te informamos que tu incidencia ha sido registrada. Asimismo, te comunicamos que:<br><br>`){

      mensaje = `Estimado ${this.user.name} <br> Te informamos que tu incidencia ha sido registrada.<br><br>`;

      mensaje += `Agradecemos el registro de tu incidencia. Nos pondremos en contacto contigo para brindarte el seguimiento correspondiente. <br>
¡Que tengas excelente día!`;

    } else { // si no solo adjuntamos texto
      mensaje += `Agradecemos el registro de tu incidencia. Nos pondremos en contacto contigo para brindarte el seguimiento correspondiente. <br>
¡Que tengas excelente día!`;
    }



    /*if (noWarranty){
      swal( "Mensaje", mensaje, "warning")
    }*/
    swal( "Mensaje", mensaje, "warning")
    //return;


    this.newItemReport = <ReportModel>{};
    if (!this.newItemReport.visits)
      this.newItemReport.visits = [];
    this.newItemReport.client = this.user;
    this.newItemReport.created_at = new Date().getTime();
    if (this.user && this.user.project_client_name)
      this.newItemReport.development = this.user.project_client_name;
    this.newItemReport.status = this.NEW_REPORT;
    this.newItemReport.statusTasks = '0/' + this.newItemsIncidents.length;
    const dateVisit = new Date();
    dateVisit.setFullYear(this.firstVisitDate.year, this.firstVisitDate.month-1, this.firstVisitDate.day);
    dateVisit.setHours(this.firstVisitTime.hour, this.firstVisitTime.minute);
    const visit: VisitModel = <VisitModel>{};
    visit.status = true;
    visit.date = this.firstVisitDate;
    visit.time = this.firstVisitTime;
    visit.assignment_date = dateVisit.getTime(); //todo: sumarle un mes
    this.newItemReport.visits.push(visit);


    this.db.collection('reports')
      .add(this.newItemReport)
      .then(async res => {

        console.log('NEW ITEMS INCIDENTS', this.newItemsIncidents);

        for (const item of this.newItemsIncidents) {
          item.status = this.NEW_INCIDENT;
          item.type = '';
          item.tasks = [];
          item.binnacle = [];
          //item.initial_evidence = [];
          item.final_evidence = [];
          item.report_reference = this.PATH_REPORTS + res.id;


          //todo: subir imágenes a storage y poner en "initial_evidence" del reporte
          const urls = await this.uploadFiles(item);
          console.log('urls', urls);
          console.log('item incident', item);
          item.initial_evidence = urls;

          this.db.collection('incident')
            .add(item)
            .then(final => {
              this.newItemReport = <ReportModel>{};
              this.newItemsIncidents = [];
              this.firstVisitDate = {};
              this.toastyService.success('El reporte se guardo exitosamente.');
              this.selectedFiles = [];
              this.previewUrls = [];

              /*emailjs.send('smtp_server', 'create_report', {
                to_name: this.user.name,
                to_email: 'garantias@entrecielosresidencial.com'
              });
              emailjs.send('smtp_server', 'create_report_user', {
                to_name: this.user.name,
                to_email: this.user.email,
                to_message: 'hemos recibido tu reporte y estaremos atendiendolo a la brevedad.'
              });*/
            }, err => {
              this.toastyService.error('El registro no fue posible realizar');
            });
        }
      });
  }

  validateStatus(status) {
    if (status == this.NEW_INCIDENT)
      return 'En espera';
    else if (status == this.PROCESS_INCIDENT)
      return 'En proceso';
    else if (status == this.DENIED_INCIDENT)
      return 'Rechazado';
    else if (status == this.FINISHED_INCIDENT)
      return 'Terminado';
  }

  saveChanges() {
    this.db.collection('users/').doc(this.user.id).update(this.user).then(() => {
      this.toastyService.success('Los datos se han guardado correctamete.');
    }).catch(() => {
      this.toastyService.error('El guardado no se pudo realizar');
    });
  }

  openProfileModal(content, openSuggest: boolean , isNewReport = '', contentSec = null) {
    this.selectedFiles = [];
    this.previewUrls = [];
    this.selectedOptionLugar = null;
    this.selectedOption = null;
    if (openSuggest) {
      this.openEmail(contentSec);
    } else {
      this.modalService.open(content).result.then((result) => {
        if (result === 'SAVE')
          this.saveChanges();
        if (isNewReport === 'NR')
          this.openNewReport(contentSec);
        else if (isNewReport === 'EM')
          this.openEmail(contentSec);
      }, (reason) => {
        if (isNewReport === 'NR')
          this.openNewReport(contentSec);
        else if (isNewReport === 'EM')
          this.openEmail(contentSec);
      });
    }
  }

  openEmail(content) {
    this.messageEmail = '';
    this.modalService.open(content).result.then((result) => {
      if (result === 'SEND') {
        emailjs.send('smtp_server', 'template_ysn4ysX9', {to_name: this.user.name, message: this.messageEmail});
        this.toastyService.success('Su mensaje ha sido enviado, gracias.');
      }
    }, (reason) => {
    });
  }

  logout() {
    this.localSt.clear('usr-ss');
    this.router.navigate(['login']);
  }

  /**
   * Función para escuchar cambio en el time picker 1
   */
  validateTime(selectedTime: NgbTimeStruct): void {
    if (
      selectedTime.hour < this.minTime.hour ||
      (selectedTime.hour === this.minTime.hour && selectedTime.minute < this.minTime.minute)
    ) {
      this.firstVisitTime = { ...this.minTime };
    } else if (
      selectedTime.hour > this.maxTime.hour ||
      (selectedTime.hour === this.maxTime.hour && selectedTime.minute > this.maxTime.minute)
    ) {
      this.firstVisitTime = { ...this.maxTime };
    } else {
      this.firstVisitTime = selectedTime;
    }
  }


  onFilesSelected(event: any): void {
    this.selectedFiles = Array.from(event.target.files);
    this.downloadUrls = []; // Clear previous URLs
    this.previewUrls = []; // Clear previous previews

    // Generate preview URLs for selected images
    this.selectedFiles.forEach((file) => {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.previewUrls.push(e.target.result);
      };
      reader.readAsDataURL(file);
    });
  }
  deleteSelectedFile(index: number){
    this.previewUrls.splice(index, 1);
  }
  uploadFiles(incident): Promise<string[]> {
    if (incident.initial_evidence.length === 0) {
      console.warn('No files selected.');
      return Promise.resolve([]); // Return an empty array if no files are selected
    }

    const selectedFiles = incident.initial_evidence as File[];
    const basePath = 'uploads';
    const uploadPromises = selectedFiles.map((file) => {
      const filePath = `${basePath}/${Date.now()}_${file.name}`;
      const fileRef = this.storage.ref(filePath);
      const task = this.storage.upload(filePath, file);

      return task
        .snapshotChanges()
        .pipe(
          finalize(() => fileRef.getDownloadURL().toPromise())
        )
        .toPromise()
        .then(() => fileRef.getDownloadURL().toPromise());
    });

    return Promise.all(uploadPromises);
  }





  timestampToDateString(timestamp){
    //console.log("timestamp", timestamp);
    const d = new Date(timestamp);
    const currentDate = this.datePipe.transform(d, "dd-MM-yyyy");
    var theString = currentDate.split("-")[0] + " de " + this.getMonthName(currentDate.split("-")[1]) + " de " + currentDate.split("-")[2];
    return theString;
  }
  timestampToTimeString(timestamp){
    const d = new Date(timestamp);
    const currentDate = this.datePipe.transform(d, "HH:mm");
    var hour = parseInt(currentDate.split(":")[0]);
    var ampm = hour >= 12 ? 'PM' : 'AM';
    return currentDate + ampm;
  }

  stringToDate(stringDate){
    const theDate = new Date(stringDate);
    theDate.setHours(theDate.getHours() + 6);
    theDate.setHours(23);
    theDate.setMinutes(59);
    theDate.setSeconds(59);
    //console.log('theDate', theDate);
    return theDate;
  }

  /**
   * Select de lugar
   */
  get filteredOptionsLugar() {
    //console.log('OPTIONS LUGAR', this.optionsLugar);
    return this.optionsLugar.filter((area) =>
      area.name.toLowerCase().includes(this.searchTermLugar.toLowerCase())
    );
  }

  toggleDropdownLugar() {
    this.dropdownLugarOpen = !this.dropdownLugarOpen;
  }

  selectOptionLugar(option: any) {
    this.newItemIncident.area = option;
    this.dropdownLugarOpen = false;
    this.searchTermLugar = '';
    this.selectedOptionLugar = option.name
  }


  /**
   * Select de tipos
   */

  get filteredOptions() {
    //console.log('OPTIONS TIPO', this.optionsTipo);
    return this.optionsTipo.filter((tipo) =>
      tipo.name.toLowerCase().includes(this.searchTerm.toLowerCase())
    );
  }

  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
  }

  selectOption(option: any) {
    this.newItemIncident.tipo = option;
    this.dropdownOpen = false;
    this.searchTerm = '';
    this.selectedOption = option.name
  }


  getMonthName(number){

    const n = parseInt(number);

    switch (n) {
      case 1:
        return "Enero";
      case 2:
        return "Febrero";
      case 3:
        return "Marzo";
      case 4:
        return "Abril";
      case 5:
        return "Mayo";
      case 6:
        return "Junio";
      case 7:
        return "Julio";
      case 8:
        return "Agosto";
      case 9:
        return "Septiembre";
      case 10:
        return "Octubre";
      case 11:
        return "Noviembre";
      case 12:
        return "Diciembre";
      default: return "no name";
    }
  }

  protected readonly DatePipe = DatePipe;
}



// WEBPACK FOOTER //
// ./src/app/public/public.component.ts